const PhotographerRecentNotes = () => <div className="client-account-block2" />

export default PhotographerRecentNotes
